import {
  useField,
  useFormFieldGroup,
  useFormSection
} from "@/components/FormBuilder/Helpers";

export const readOnlyFields = (agencyHasUnderwriter: boolean) => {
  const baseForm = [
    ...useFormSection(
      [
        ...useFormFieldGroup(
          [
            useField({
              key: "agencyName",
              label: "Agency Name",
              type: "dataview",
              conditions: {
                and: [
                  {
                    operator: "exists",
                    field: "status",
                    value: true
                  }
                ]
              }
            }),
            useField({
              key: "status",
              label: "Agency Status",
              type: "dataview",
              conditions: {
                and: [
                  {
                    operator: "exists",
                    field: "status",
                    value: true
                  }
                ]
              }
            }),
            useField({
              key: "agencyCode",
              label: "Agency Code",
              type: "dataview",
              conditions: {
                and: [
                  {
                    operator: "exists",
                    field: "agencyCode",
                    value: true
                  }
                ]
              }
            })
          ],
          { layout: "3-col" }
        ),
        ...useFormFieldGroup(
          [
            useField({
              key: "parentAgency.agencyName",
              label: "Sub Agency Of",
              type: "dataview",
              conditions: {
                and: [
                  {
                    operator: "exists",
                    field: "subAgencyOf",
                    value: true
                  }
                ]
              }
            }),
            useField({
              key: "parentAgencyCode",
              label: "Parent Agency Code",
              type: "dataview",
              conditions: {
                and: [
                  {
                    operator: "exists",
                    field: "parentAgencyCode",
                    value: true
                  }
                ]
              }
            })
          ],
          { layout: "3-col" }
        )
      ],
      {
        title: "Agency Information",
        description: "Provide some basic information about the agency"
      }
    )
  ];

  if (agencyHasUnderwriter) {
    baseForm.push(
      ...useFormSection(
        [
          ...useFormFieldGroup(
            [
              useField({
                key: "underWriterData.fullName",
                label: "Underwriter Name",
                type: "dataview",
                conditions: {
                  and: [
                    {
                      operator: "exists",
                      field: "underWriterData.fullName",
                      value: true
                    }
                  ]
                }
              })
            ],
            { layout: "full" }
          ),
          ...useFormFieldGroup(
            [
              useField({
                key: "underWriterData.email",
                type: "dataview",
                label: "Email",
                conditions: {
                  and: [
                    {
                      operator: "exists",
                      field: "underWriterData.email",
                      value: true
                    }
                  ]
                }
              }),
              useField({
                key: "underWriterData.phone.primary",
                label: "Primary Phone number",
                type: "dataview",
                conditions: {
                  and: [
                    {
                      operator: "exists",
                      field: "underWriterData.phone.primary",
                      value: true
                    }
                  ]
                }
              }),
              useField({
                key: "underWriterData.phone.secondary",
                label: "Secondary Phone number",
                type: "dataview",
                conditions: {
                  and: [
                    {
                      operator: "exists",
                      field: "underWriterData.phone.secondary",
                      value: true
                    }
                  ]
                }
              })
            ],
            { layout: "2-col" }
          )
        ],

        {
          title: "Underwriter Information",
          description: "Information about the underwriter assigned the agency"
        }
      )
    );
  }
  return baseForm;
};

export function readOnlyAgencyFormFields(agencyHasUnderwriter: boolean) {
  return readOnlyFields(agencyHasUnderwriter);
}
